import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const OpenPrice: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return <FullInfoField label="openPricePercentLabel" value={dishForFullInfo?.openPrice} />;
};
